NtechApp.ResumeDateField = function($view) {
    var me = this;

    this._$view = null;
    this._click = null;

    this._construct = function() {
        me._$view = $view;
        me._click = new NtechApp.TouchClickEvent();

        me._bindAllForms();

        me._bindEvents();
    }

    this._bindEvents = function() {

    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.ResumeDateField, {
    _bindAllForms: function() {
        var me = this;
        $.each(this._$view.find("[data-formTab]"), function() {
            if($(this).attr("data-formTab") == "e")
                return;

            me.bindFormDateFields($(this));
        });
    },

    _getSelect: function($selects, namePrefix) {
        var $select = null;
        $.each($selects, function() {
            if($(this).attr("data-customSelectId").search(namePrefix) !== -1)
                $select = $(this);
        });

        return NtechApp.formManager.getFormSelectById($select.attr("data-customSelectId"));
    },

    _getRadio: function($radios, namePrefix) {
        var $radio = null;
        $.each($radios, function() {
            if($(this).attr("data-customRadioId").search(namePrefix) !== -1)
                $radio = $(this);
        });

        return NtechApp.formManager.getRadioBoxById($radio.attr("data-customRadioId"));
    },

    bindFormDateFields: function($form) {
        var $formWrapper = $form.closest("[data-multipleFormNav]");
        var $formNav = $formWrapper.find("[data-formNavRoot]");

        var $navItem = $formNav.find("[data-formRow='" + $form.attr("data-formTab") + "']");
        var $allFormSelects = $form.find("[data-customSelectId]");

        var startMonthSelect = this._getSelect($allFormSelects, "startMonth");
        var startYearSelect = this._getSelect($allFormSelects, "startYear");
        var endMonthSelect = this._getSelect($allFormSelects, "endMonth");
        var endYearSelect = this._getSelect($allFormSelects, "endYear");

        var $allFormRadios = $form.find("[data-customRadioId]");
        var isPresentRadio = this._getRadio($allFormRadios, "isPresent");

        var controls = {
            $navItem: $navItem,
            startMonth: startMonthSelect,
            startYear: startYearSelect,
            endMonth: endMonthSelect,
            endYear: endYearSelect,
            isPresent: isPresentRadio
        };

        this._syncEndDateSelect(controls, true);
        this._bindIsPresentChangeEvent(controls);

        this._syncNavTabLabel(controls);
        this._bindDateTimelineChangeEvent(controls);
    },

    _bindIsPresentChangeEvent: function(controls) {
        var me = this;
        $(controls.isPresent).on(NtechApp.RadioBox.EVENT_VALUE_CHANGE, function(e, val) {
            if(parseInt(val, 10))
                me._lockEndDateSelect(controls);
            else
                me._unlockEndDateSelect(controls);
        });
    },

    _syncEndDateSelect: function(controls, initial) {
        var initial = initial || false; 
        var value = parseInt(controls.isPresent.val(), 10) || 0; 
        
        if(value)
            this._lockEndDateSelect(controls);
        else
            this._unlockEndDateSelect(controls, initial);
    },

    _lockEndDateSelect: function(controls) {
        controls.endMonth.clearVal("Present");
        controls.endYear.clearVal("Present");

        controls.endMonth.lock();
        controls.endYear.lock();
    },

    _unlockEndDateSelect: function(controls, initial) {
        // Do not clear vals when you are setting initial selects state!
        if(!initial) {
            controls.endMonth.clearVal("");
            controls.endYear.clearVal("");
        }

        controls.endMonth.simpleUnlock();
        controls.endYear.simpleUnlock();
    },

    _syncNavTabLabel: function(controls, forceDefault) {
        var forceDefault = forceDefault || false;
        var defaultLabel = this._$view.find("[data-formNavRoot]").attr("data-listItemPrototype");

        var startMonth = controls.startMonth.getLabel();
        var startYear = controls.startYear.getLabel();
        var endMonth = controls.endMonth.getLabel();
        var endYear = controls.endYear.getLabel();

        if(startMonth.length == 0 || startYear.length == 0 ||
            endMonth.length == 0 || endYear.length == 0 || forceDefault) {
            controls.$navItem.find(".label").text(defaultLabel);
            return;
        }

        var getMonth = function(str) {
            return str.substr(0, 3);
        };

        var label = getMonth(startMonth) + "/" + startYear + "-";
        if(endMonth == "Present")
            label += "Present";
        else
            label += getMonth(endMonth) + "/" + endYear;

        controls.$navItem.find(".label").text(label);
    },

    _bindDateTimelineChangeEvent: function(controls) {
        var me = this;
        var selectEventHandler = function(controls) {
            var isValid = me._checkEndDate(controls);
            me._syncNavTabLabel(controls, !isValid);
        };

        $(controls.startMonth).on(NtechApp.SelectForm.EVENT_OPTION_SELECT, function() {
            selectEventHandler(controls);
        });
        $(controls.startYear).on(NtechApp.SelectForm.EVENT_OPTION_SELECT, function() {
            selectEventHandler(controls);
        });
        $(controls.endMonth).on(NtechApp.SelectForm.EVENT_OPTION_SELECT, function() {
            selectEventHandler(controls);
        });
        $(controls.endYear).on(NtechApp.SelectForm.EVENT_OPTION_SELECT, function() {
            selectEventHandler(controls);
        });

        $(controls.isPresent).on(NtechApp.RadioBox.EVENT_VALUE_CHANGE, function() {
            me._syncNavTabLabel(controls);
        });
    },

    _checkEndDate: function(controls) {
        var startMonth = controls.startMonth.getLabel();
        var startYear = controls.startYear.getLabel();
        var endMonth = controls.endMonth.getLabel();
        var endYear = controls.endYear.getLabel();

        if(endMonth == "Present")
            return true;

        if(endMonth == "" || endYear == "")
            return true;

        var startDate = new Date(startMonth + " " + startYear).getTime();
        var endDate = new Date(endMonth + " " + endYear).getTime();

        var diff = endDate - startDate;
        if(diff < 0) {
            NtechApp.info.on("End date must be greater than start date", 2500);
            controls.endYear.clearVal();

            return false;
        }

        return true;
    }
});